/* UI behaviors ported verbatim from the mockup's assets/js/app.js: coverflow, hero/scene fit,
   background films, recipe films, parallax, tabs, shop accordion, marquee, editorial motion.
   Generated by build-shopify/make-ui-js.mjs — edit the mockup source or this generator, not this file. */
(() => {
const $ = (s, r = document) => r.querySelector(s);
const $$ = (s, r = document) => [...r.querySelectorAll(s)];

const MASK_ZOOM = '.rounded[data-reveal="scale"], .jr-fig, .cg__item';
const MASK_CLIP = '.rw-card__frame';
const SPLIT_HEADINGS = 'h2.dh, .page-head__title, .jr__title';

const reducedMotion = () => matchMedia('(prefers-reduced-motion: reduce)').matches;


function onFrame(fn) {
  let queued = false;
  const run = () => { queued = false; fn(); };
  const kick = () => { if (!queued) { queued = true; requestAnimationFrame(run); } };
  addEventListener('scroll', kick, { passive: true });
  addEventListener('resize', kick);
  fn();
  return kick;
}

function initShopAccordion() {
  const groups = $$('[data-shop-accordion]');
  if (!groups.length) return;
  if (!matchMedia('(hover: hover) and (min-width: 1024px)').matches) return;

  const ACTIVE_PCT = 34;

  groups.forEach(group => {
    const panels = $$('.shop-accordion__panel', group);
    if (panels.length < 2) return;
    const restPct = (100 - ACTIVE_PCT) / (panels.length - 1);

    /* Staggering flex-basis by distance from the active panel is what turns
       the motion into a sweep travelling outward from the pointer instead of
       every panel snapping to its new width on the same frame. Skipped on
       the initial call (stagger=false): setting an inline transition-delay
       there would win over the [data-reveal] entrance's own --reveal-delay
       stagger before the visitor has interacted with anything. */
    const setActive = (activeIdx, stagger = true) => {
      panels.forEach((p, i) => {
        const isActive = i === activeIdx;
        p.classList.toggle('is-active', isActive);
        p.style.setProperty('--panel-w', `${isActive ? ACTIVE_PCT : restPct}%`);
        if (stagger) p.style.transitionDelay = `${Math.min(Math.abs(i - activeIdx), 5) * 20}ms`;
        p.setAttribute('aria-expanded', String(isActive));
      });
    };

    /* --panel-w starts undefined, so this first call is itself a value
       change (CSS fallback 10% -> the computed rest/active split) — which,
       same as any other flex-basis change, would trigger the 820ms sweep
       transition. Left alone, every page load would visibly (and, on very
       wide viewports, momentarily overflow-causing) animate the accordion
       into its resting layout. Suppress transitions for this one call only,
       so the panels are correct from the first paint. */
    group.classList.add('shop-accordion--no-transition');
    setActive(0, false);
    group.offsetHeight; // force layout so the no-transition state commits
    group.classList.remove('shop-accordion--no-transition');

    panels.forEach((p, i) => {
      p.addEventListener('mouseenter', () => setActive(i));
      p.addEventListener('focus', () => setActive(i));
    });
    group.addEventListener('mouseleave', () => setActive(0));
    group.addEventListener('focusout', e => {
      if (!group.contains(e.relatedTarget)) setActive(0);
    });
  });
}

function initMarquee() {
  /* Clone the track once so the -50% translate loops seamlessly */
  $$('.marquee__track').forEach(track => {
    if (track.dataset.doubled) return;
    track.append(...[...track.children].map(n => n.cloneNode(true)));
    track.dataset.doubled = '1';
  });
}

function initYear() {
  $$('.js-year').forEach(el => { el.textContent = new Date().getFullYear(); });
}

function initTabs() {
  $$('[data-tabs]').forEach(root => {
    const tabs   = $$('[data-tab]', root);
    const panels = tabs.map(t => document.getElementById(t.dataset.tab)).filter(Boolean);
    if (!tabs.length || panels.length !== tabs.length) return;
    root.classList.add('is-tabbed');

    const owner = id => {
      const el = id && document.getElementById(id);
      return el ? panels.find(p => p === el || p.contains(el)) : null;
    };
    const show = (panel, { scroll = false, push = false } = {}) => {
      panels.forEach(p => { p.hidden = p !== panel; });
      tabs.forEach(t => t.setAttribute('aria-current', String(t.dataset.tab === panel.id)));
      /* On a phone the row scrolls sideways: bring the active button into view. */
      const on = tabs.find(t => t.dataset.tab === panel.id), row = on?.parentElement;
      if (row && row.scrollWidth > row.clientWidth) row.scrollLeft = on.offsetLeft - (row.clientWidth - on.offsetWidth) / 2;
      if (push) history.replaceState(null, '', '#' + panel.id);
      if (scroll) root.scrollIntoView({ block: 'start' });
    };

    tabs.forEach(t => t.addEventListener('click', e => {
      e.preventDefault();
      show(document.getElementById(t.dataset.tab), { push: true, scroll: true });
    }));
    const fromHash = () => {
      const id = location.hash.slice(1), p = owner(id), el = id && document.getElementById(id);
      if (!p) return;
      show(p, { scroll: el === p });
      if (el && el !== p) el.scrollIntoView({ block: 'start' });
    };
    window.addEventListener('hashchange', fromHash);
    show(owner(location.hash.slice(1)) || panels[0], { scroll: !!owner(location.hash.slice(1)) });
  });
}

function initParallax() {
  const els = $$('[data-parallax]');
  if (!els.length || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  let ticking = false;
  const update = () => {
    ticking = false;
    els.forEach(el => {
      const frame = el.parentElement.getBoundingClientRect();
      const vh = innerHeight;
      if (frame.bottom < -100 || frame.top > vh + 100) return;
      const p = Math.max(-1, Math.min(1, (frame.top + frame.height / 2 - vh / 2) / (vh / 2 + frame.height / 2)));
      el.style.transform = `translate3d(0, ${(-p * frame.height * 0.11).toFixed(1)}px, 0)`;
    });
  };
  const onScroll = () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } };
  addEventListener('scroll', onScroll, { passive: true });
  addEventListener('resize', onScroll);
  update();
}

function initHeroFit() {
  const hero = $('.scene--hero');
  if (!hero) return;
  /* The hero is pulled up under the header (margin-top: -chrome), so its own top no
     longer says how much chrome there is: measure where <main> starts, plus the
     breadcrumb that sits above an interior hero. */
  const main = $('main');
  const lead = hero.previousElementSibling;
  const set = () => {
    const base = (main ? main.getBoundingClientRect().top : hero.getBoundingClientRect().top) + scrollY;
    const crumbs = lead && lead.classList.contains('crumbs') ? lead.offsetHeight : 0;
    document.documentElement.style.setProperty('--chrome-h', Math.round(base + crumbs) + 'px');
  };
  set();
  addEventListener('resize', set);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(set);
}

function initBgVideos() {
  const vids = $$('[data-hero-video]');
  if (!vids.length) return;
  /* a film's photograph sits inert in <template data-fallback>; it is put on screen
     only when the film cannot play */
  const showFallback = v => { const t = v.closest('.scene__media')?.querySelector('template[data-fallback]'); if (t) t.replaceWith(t.content.cloneNode(true)); };
  const c = navigator.connection;
  if (matchMedia('(prefers-reduced-motion: reduce)').matches || (c && (c.saveData || /(^|-)2g$/.test(c.effectiveType || '')))) { vids.forEach(showFallback); return; }
  const wide = matchMedia('(min-width: 1024px)').matches;
  const codecs = wide
    ? { av1: 'video/mp4; codecs="av01.0.08M.08"', h264: 'video/mp4; codecs="avc1.640028"' }
    : { av1: 'video/mp4; codecs="av01.0.05M.08"', h264: 'video/mp4; codecs="avc1.64001F"' };
  vids.forEach(v => {
    const files = JSON.parse(v.dataset.heroVideo);
    const list = wide ? files.wide : files.narrow;
    const pick = list.find(([k]) => v.canPlayType(codecs[k]) === 'probably')
              || list.find(([k]) => k === 'h264' && v.canPlayType(codecs.h264));
    if (!pick) { showFallback(v); return; }
    let started = false, onScreen = false;
    const start = () => {
      if (started) return;
      started = true;
      v.addEventListener('playing', () => v.classList.add('is-playing'), { once: true });
      v.addEventListener('error', () => showFallback(v), { once: true });
      v.src = pick[1];
      if (onScreen) v.play().catch(() => {});
    };
    new IntersectionObserver(([en]) => {
      onScreen = en.isIntersecting;
      if (!started) return;
      onScreen ? v.play().catch(() => {}) : v.pause();
    }, { threshold: 0.05 }).observe(v);
    if (files.lazy) {
      new IntersectionObserver((es, o) => { if (es[0].isIntersecting) { o.disconnect(); start(); } }, { rootMargin: '100% 0px' }).observe(v);
    } else {
      document.readyState === 'loading' ? addEventListener('DOMContentLoaded', start, { once: true }) : start();
    }
  });
}

function initRecipeFilms() {
  const links = $$('[data-rw]');
  if (!links.length) return;
  const av1 = document.createElement('video').canPlayType('video/mp4; codecs="av01.0.05M.08"') === 'probably';
  links.forEach(a => a.addEventListener('click', e => {
    e.preventDefault();
    const id = a.dataset.rw;
    $$('.rw-card__video').forEach(v => { v.pause(); v.closest('.rw-card__frame').querySelector('[data-rw]').hidden = false; v.remove(); });
    const v = document.createElement('video');
    v.className = 'rw-card__video';
    v.controls = true; v.playsInline = true; v.autoplay = true; v.preload = 'auto';
    v.setAttribute('aria-label', a.getAttribute('aria-label').replace(/^Play: /, ''));
    v.src = (av1 ? a.dataset.srcAv1 : a.dataset.srcH264) || a.href;
    a.closest('.rw-card__frame').appendChild(v);
    a.hidden = true;
    v.addEventListener('ended', () => { a.hidden = false; v.remove(); });
    v.focus({ preventScroll: true });
  }));
}

function initCoverflow() {
  $$('[data-coverflow]').forEach(root => {
    const cards = $$('.cf-card', root);
    const dots = $$('[data-cf-dot]', root);
    const n = cards.length;
    if (n < 2) return;
    const section = root.closest('.coverflow');
    const bgs = section ? $$('.coverflow__bg', section) : [];
    let idx = 0, hover = false, focused = false, visible = false, x0 = 0;

    const apply = () => {
      cards.forEach((c, i) => {
        let off = ((i - idx) % n + n) % n;
        if (off > n / 2) off -= n;
        c.dataset.pos = String(off);
        const live = off === 0;
        c.querySelectorAll('a, button').forEach(a => { a.tabIndex = live ? 0 : -1; });
        c.setAttribute('aria-hidden', String(!live));
        c.toggleAttribute('inert', !live);
      });
      dots.forEach((d, i) => d.setAttribute('aria-current', String(i === idx)));
      bgs.forEach((b, i) => b.classList.toggle('is-on', i === idx));
    };
    const go = i => { idx = ((i % n) + n) % n; apply(); };

    root.classList.add('is-live');
    $$('.cf__nav', root).forEach(b => { b.hidden = false; });
    const dotsBox = $('.cf__dots', root);
    if (dotsBox) dotsBox.hidden = false;
    apply();

    root.addEventListener('click', e => {
      const nav = e.target.closest('[data-cf]');
      if (nav) return go(idx + (nav.dataset.cf === 'next' ? 1 : -1));
      const dot = e.target.closest('[data-cf-dot]');
      if (dot) return go(Number(dot.dataset.cfDot));
      const card = e.target.closest('.cf-card');
      if (card && card.dataset.pos !== '0' && !e.target.closest('a')) go(Number(card.dataset.i));
    });
    /* arrow keys only while the carousel is under the pointer or holds focus —
       never hijacking the page's own scrolling keys elsewhere */
    root.addEventListener('focusin', () => { focused = true; });
    root.addEventListener('focusout', () => { focused = false; });
    document.addEventListener('keydown', e => {
      if (!(hover || focused) || /^(INPUT|TEXTAREA|SELECT)$/.test(document.activeElement.tagName)) return;
      if (e.key === 'ArrowLeft') go(idx - 1);
      if (e.key === 'ArrowRight') go(idx + 1);
    });
    root.addEventListener('touchstart', e => { x0 = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', e => {
      const d = e.changedTouches[0].clientX - x0;
      if (Math.abs(d) > 45) go(idx + (d < 0 ? 1 : -1));
    }, { passive: true });
    root.addEventListener('mouseenter', () => { hover = true; });
    root.addEventListener('mouseleave', () => { hover = false; });

    if (!matchMedia('(prefers-reduced-motion: reduce)').matches) {
      new IntersectionObserver(([en]) => { visible = en.isIntersecting; }, { threshold: 0.35 }).observe(root);
      setInterval(() => { if (visible && !hover && !focused && !document.hidden) go(idx + 1); }, 5000);
    }
  });
}

function initSceneFit() {
  const scenes = $$('.scene:not(.scene--compact):not(.scene--page)');
  if (!scenes.length) return;
  let queued = false, lastW = -1, lastH = -1;
  const fit = (force = false) => {
    queued = false;
    /* a phone's address bar growing and shrinking fires resize on every scroll; only a
       real change of width, or a height change big enough to matter, re-measures */
    if (!force && innerWidth === lastW && Math.abs(innerHeight - lastH) < 120) return;
    lastW = innerWidth; lastH = innerHeight;
    scenes.forEach(s => {
      const c = s.querySelector('.scene__content');
      if (!c) return;
      s.classList.remove('scene--grow');
      if (c.scrollHeight > c.clientHeight + 2) s.classList.add('scene--grow');
    });
  };
  const kick = (force = false) => { if (!queued) { queued = true; requestAnimationFrame(() => fit(force === true)); } };
  addEventListener('resize', () => kick());
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => kick(true));
  addEventListener('load', () => kick(true));
  fit(true);
}

function initHeroDepth() {
  const hero = $('.scene--hero');
  if (!hero || reducedMotion()) return;
  let last = -1;
  onFrame(() => {
    const p = Math.max(0, Math.min(1, scrollY / (innerHeight * 0.85)));
    if (Math.abs(p - last) < 0.002) return;
    last = p;
    hero.style.setProperty('--hero-p', p.toFixed(3));
  });
}

function initSpine() {
  const list = $('.jr-list');
  if (!list) return;
  if (reducedMotion()) { list.style.setProperty('--spine', '1'); return; }
  onFrame(() => {
    const r = list.getBoundingClientRect();
    const p = Math.max(0, Math.min(1, (innerHeight * 0.6 - r.top) / r.height));
    list.style.setProperty('--spine', p.toFixed(4));
  });
}

function splitWords(el) {
  let wi = 0;
  const walk = node => {
    [...node.childNodes].forEach(n => {
      if (n.nodeType === 3) {
        const frag = document.createDocumentFragment();
        n.textContent.split(/(\s+)/).forEach(part => {
          if (!part) return;
          if (/^\s+$/.test(part)) { frag.append(document.createTextNode(part)); return; }
          const w = document.createElement('span');
          const i = document.createElement('span');
          w.className = 'w'; i.className = 'w__i';
          i.style.setProperty('--wi', String(wi++));
          i.textContent = part;
          w.append(i);
          frag.append(w);
        });
        n.replaceWith(frag);
      } else if (n.nodeType === 1 && n.tagName !== 'BR') walk(n);
    });
  };
  walk(el);
}

function initMotion() {
  if (reducedMotion() || !('IntersectionObserver' in window)) return;

  /* Headings are observed normally. A masked photograph cannot be: the observer
     measures the clipped box (zero area) and never fires, so masks are opened by
     position instead, from the same one-frame scroll listener as everything else. */
  const io = new IntersectionObserver(entries => {
    entries.forEach(en => {
      if (!en.isIntersecting) return;
      en.target.classList.add('is-split-in');
      io.unobserve(en.target);
    });
  }, { rootMargin: '0px 0px -6% 0px', threshold: 0.12 });

  let pending = [];
  const mark = (sel, kind) => $$(sel).forEach(el => {
    if (el.hasAttribute('data-mask')) return;
    if (el.hasAttribute('data-reveal')) el.removeAttribute('data-reveal');   // the mask is its entrance
    el.setAttribute('data-mask', kind);
    const idx = [...el.parentElement.children].indexOf(el);
    el.style.setProperty('--reveal-delay', `${Math.min(idx, 4) * 80}ms`);
    pending.push(el);
  });
  mark(MASK_ZOOM, '');
  mark(MASK_CLIP, 'clip');
  if (pending.length) {
    const kick = onFrame(() => {
      const line = innerHeight * 0.92, near = innerHeight * 1.8;
      pending = pending.filter(el => {
        const r = el.getBoundingClientRect();
        const img = el.querySelector('img');
        /* A lazy image inside a clipped box is never "visible" to the browser, so the
           browser never fetches it, and a mask waiting for it would never open. The
           image is fetched by position instead, a couple of screens before it is due. */
        if (img && img.loading === 'lazy' && r.top < near && r.bottom > -near) img.loading = 'eager';
        if (r.top < line && r.bottom > 0) {
          /* open on a picture, not on a gap: wait for the image, but never for long */
          if (img && !img.complete) {
            const seen = el._seen || (el._seen = Date.now());
            if (Date.now() - seen < 2500) {
              img.addEventListener('load', () => kick(), { once: true });
              setTimeout(() => kick(), 2600);
              return true;
            }
          }
          el.classList.add('is-in');
          return false;
        }
        return true;
      });
    });
    /* a tab or a hash jump reveals photographs without any scroll */
    document.addEventListener('click', () => setTimeout(kick, 80));
    addEventListener('hashchange', () => setTimeout(kick, 80));
  }

  $$(SPLIT_HEADINGS).forEach(h => {
    if (h.closest('.scene--hero, .scene--page')) return;   // first-screen titles use the CSS entrance
    splitWords(h);
    io.observe(h);
  });
}

const boot = () => {
  initShopAccordion();
  initMarquee();
  initYear();
  initTabs();
  initParallax();
  initHeroFit();
  initBgVideos();
  initRecipeFilms();
  initCoverflow();
  initSceneFit();
  initHeroDepth();
  initSpine();
  initMotion();
};
document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', boot) : boot();
})();
